import { concat } from '../../helpers/common'

const MODULE_NAME = 'SELF_ACCOUNTS/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION

export const GET_SELF_ACCOUNTS = concat(MODULE_NAME, 'GET_SELF_ACCOUNTS')
export const GET_SELF_ACCOUNTS_SUCCESS = concat(MODULE_NAME, 'GET_SELF_ACCOUNTS_SUCCESS')
export const GET_SELF_ACCOUNTS_FAILURE = concat(MODULE_NAME, 'GET_SELF_ACCOUNTS_FAILURE')
export const CLEAR_SELF_ACCOUNTS = concat(MODULE_NAME, 'CLEAR_SELF_ACCOUNTS')

export const GET_SELF_ACCOUNT = concat(MODULE_NAME, 'GET_SELF_ACCOUNT')
export const GET_SELF_ACCOUNT_SUCCESS = concat(MODULE_NAME, 'GET_SELF_ACCOUNT_SUCCESS')
export const GET_SELF_ACCOUNT_FAILURE = concat(MODULE_NAME, 'GET_SELF_ACCOUNT_FAILURE')
export const CLEAR_SELF_ACCOUNT = concat(MODULE_NAME, 'CLEAR_SELF_ACCOUNT')

export const GET_PARTNER_SELF_ACCOUNT = concat(MODULE_NAME, 'GET_PARTNER_SELF_ACCOUNT')
export const GET_PARTNER_SELF_ACCOUNT_SUCCESS = concat(MODULE_NAME, 'GET_PARTNER_SELF_ACCOUNT_SUCCESS')
export const GET_PARTNER_SELF_ACCOUNT_FAILURE = concat(MODULE_NAME, 'GET_PARTNER_SELF_ACCOUNT_FAILURE')
export const CLEAR_PARTNER_SELF_ACCOUNT = concat(MODULE_NAME, 'CLEAR_PARTNER_SELF_ACCOUNT')

export const CREATE_SELF_ACCOUNT = concat(MODULE_NAME, 'CREATE_SELF_ACCOUNT')
export const CREATE_SELF_ACCOUNT_SUCCESS = concat(MODULE_NAME, 'CREATE_SELF_ACCOUNT_SUCCESS')
export const CREATE_SELF_ACCOUNT_FAILURE = concat(MODULE_NAME, 'CREATE_SELF_ACCOUNT_FAILURE')
export const CLEAR_CREATE_SELF_ACCOUNT = concat(MODULE_NAME, 'CLEAR_CREATE_SELF_ACCOUNT')

export const UPDATE_SELF_ACCOUNT = concat(MODULE_NAME, 'UPDATE_SELF_ACCOUNT')
export const UPDATE_SELF_ACCOUNT_SUCCESS = concat(MODULE_NAME, 'UPDATE_SELF_ACCOUNT_SUCCESS')
export const UPDATE_SELF_ACCOUNT_FAILURE = concat(MODULE_NAME, 'UPDATE_SELF_ACCOUNT_FAILURE')
export const CLEAR_UPDATE_SELF_ACCOUNT = concat(MODULE_NAME, 'CLEAR_UPDATE_SELF_ACCOUNT')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// get self accounts
export function getSelfAccounts(params) {
  return { type: GET_SELF_ACCOUNTS, params }
}

export function getSelfAccountsSuccess(selfAccountsData) {
  return { type: GET_SELF_ACCOUNTS_SUCCESS, selfAccountsData }
}

export function getSelfAccountsFailure(error) {
  return { type: GET_SELF_ACCOUNTS_SUCCESS, error }
}

export function clearSelfAccounts() {
  return { type: CLEAR_SELF_ACCOUNTS }
}

// get self account
export function getSelfAccount(id, showErrorToast) {
  return { type: GET_SELF_ACCOUNT, id, showErrorToast }
}

export function getSelfAccountSuccess(data) {
  return { type: GET_SELF_ACCOUNT_SUCCESS, data }
}

export function getSelfAccountFailure(error) {
  return { type: GET_SELF_ACCOUNT_FAILURE, error }
}

export function clearSelfAccount() {
  return { type: CLEAR_SELF_ACCOUNT }
}

// get self account
export function getPartnerSelfAccount(id) {
  return { type: GET_PARTNER_SELF_ACCOUNT, id }
}

export function getPartnerSelfAccountSuccess(data) {
  return { type: GET_PARTNER_SELF_ACCOUNT_SUCCESS, data }
}

export function getPartnerSelfAccountFailure(error) {
  return { type: GET_PARTNER_SELF_ACCOUNT_FAILURE, error }
}

export function clearPartnerSelfAccount() {
  return { type: CLEAR_PARTNER_SELF_ACCOUNT }
}

// create self account
export function createSelfAccount(selfAccountData, selectSelfAccountOnSuccess) {
  return { type: CREATE_SELF_ACCOUNT, selfAccountData, selectSelfAccountOnSuccess }
}

export function createSelfAccountSuccess(selfAccountData) {
  return { type: CREATE_SELF_ACCOUNT_SUCCESS, selfAccountData }
}

export function createSelfAccountFailure(error) {
  return { type: CREATE_SELF_ACCOUNT_FAILURE, error }
}

export function clearCreateSelfAccount() {
  return { type: CLEAR_CREATE_SELF_ACCOUNT }
}

// update self account
export function updateSelfAccount(id, selfAccountData) {
  return { type: UPDATE_SELF_ACCOUNT, id, selfAccountData }
}

export function updateSelfAccountSuccess(selfAccountData) {
  return { type: UPDATE_SELF_ACCOUNT_SUCCESS, selfAccountData }
}

export function updateSelfAccountFailure(error) {
  return { type: UPDATE_SELF_ACCOUNT_FAILURE, error }
}

export function clearUpdateSelfAccount() {
  return { type: CLEAR_UPDATE_SELF_ACCOUNT }
}
